/* Auto-extracted from oatentik-hero-shipping-badges.liquid section. Config via window.OAT_HERO_CFG. */

(function () {
  var C = (window.OAT_HERO_CFG || {});
  if (window.__oatentikPdpInit) return;
  window.__oatentikPdpInit = true;

  /* Parse embedded variant data */
  var variants = [];
  try {
    var d = document.getElementById('oatentik-variant-data');
    if (d) variants = JSON.parse(d.textContent);
  } catch (e) {}
  window.oatentikVariants = variants;

  /* Render money with de-emphasized cents so the whole-euro integer dominates
     (e.g. 19,20€ reads as a big "19" + small ",20"). Whole prices have their
     ,00 stripped server-side so they have no decimals and stay unchanged. Only
     a separator followed by exactly two trailing digits is matched, so thousands
     groupings and the currency symbol are left intact. */
  function oatSmallCents(s) {
    if (s == null) return '';
    return String(s).replace(/(\d)([.,])(\d{2})(?!\d)/, '$1<small class="oat-cents">$2$3</small>');
  }
  function oatSetMoney(el, s) {
    if (!el) return;
    s = (s == null ? '' : String(s));
    if (el._oatMoneyRaw === s) return;
    el._oatMoneyRaw = s;
    el.innerHTML = oatSmallCents(s);
  }
  (function injectCentsCss() {
    if (document.getElementById('oat-cents-css')) return;
    var st = document.createElement('style');
    st.id = 'oat-cents-css';
    st.textContent = '.oat-cents{font-size:.64em;font-weight:inherit;letter-spacing:0;vertical-align:.28em;opacity:.92}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* α-amylase explainer toggle, delegated so it works in the modal + accordion clones */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.oatentik-nutrition-card__info') : null;
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.oatentik-nutrition-card');
    var pop = card ? card.querySelector('.oatentik-nutrition-card__amylase') : null;
    if (!pop) return;
    if (pop.hasAttribute('hidden')) { pop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
    else { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
  });

  var BUTTON_LABEL = C.k3;
  var PACK_LABEL = C.k4;
  var SHIPS_LABEL = C.k1;
  var DELIVERY_LABEL = C.k2;
  /* short delivery word for mobile (full "Estimated delivery" is too long for one line) */
  var DELIVERY_SHORT = ({"en":"Delivery","sl":"Dostava","de":"Lieferung","fr":"Livraison","it":"Consegna","es":"Entrega","pt-pt":"Entrega","nl":"Levering","pl":"Dostawa","cs":"Doručení","sk":"Doručenie","hr":"Dostava","hu":"Kézbesítés"})[C.k5] || DELIVERY_LABEL;
  var POPULAR_LABEL = C.k6;
  var BESTVALUE_LABEL = C.k7;
  var SAVE_LABEL = C.k8;
  var PERL_LABEL = C.k9;
  var PACK_ICONS = { "1": C.k10, "2": C.k11, "4": C.k12 };
  var FROM_LABEL = C.k13;
  var L_LABEL = C.k14;
  var L_UNIT = C.k15;
  var STICKY_CALC_LABEL = C.k16;

  var ICON_DOC = '<svg class="oatentik-nutrition-cta__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M14 3v5h5" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<line x1="9" y1="13" x2="16" y2="13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '<line x1="9" y1="16.5" x2="16" y2="16.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '<line x1="9" y1="20" x2="13" y2="20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';
  var ICON_TRUCK = '<svg class="oatentik-trust-line__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 7h11v9H2z" stroke="currentColor" stroke-width="1.5"/><path d="M13 10h4l4 3v3h-8z" stroke="currentColor" stroke-width="1.5"/><circle cx="6" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.4" fill="#fff"/><circle cx="17" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.4" fill="#fff"/></svg>';

  /* ----- How-to use-case chip icons (inline line icons, currentColor) ----- */
  var ICON_COFFEE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8h13v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M17 9.5h1.8a2.7 2.7 0 0 1 0 5.4H17" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M7.5 2.6v2.1M10.5 2.6v2.1M13.5 2.6v2.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_MATCHA = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 19C5 11 11 5 19 5c0 8-6 14-14 14Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5 19 13 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_CEREAL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 11h17a8.5 8.5 0 0 1-8.5 8 8.5 8.5 0 0 1-8.5-8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><ellipse cx="15" cy="6.4" rx="1.7" ry="2.3" stroke="currentColor" stroke-width="1.4"/><path d="M15 8.7V11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var ICON_SMOOTHIE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 7h10l-1 12.4a1.6 1.6 0 0 1-1.6 1.5H9.6A1.6 1.6 0 0 1 8 19.4L7 7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M7.5 11h9" stroke="currentColor" stroke-width="1.4"/><path d="M13.5 7 16.5 2.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_PANCAKE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><ellipse cx="12" cy="8" rx="8" ry="3" stroke="currentColor" stroke-width="1.6"/><path d="M4 8v3c0 1.66 3.58 3 8 3s8-1.34 8-3V8" stroke="currentColor" stroke-width="1.6"/><path d="M4 13.5v3c0 1.66 3.58 3 8 3s8-1.34 8-3v-3" stroke="currentColor" stroke-width="1.6"/></svg>';
  var ICON_COOKING = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9h14v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M2.5 11h1.5M18 11h3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M8.5 9c0-2 .8-3.4 0-5M13 9c0-2 .8-3.4 0-5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var ICON_SHIP = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h10v8H3z" stroke="currentColor" stroke-width="1.8"/><path d="M13 10h4l3 3v2h-7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="16.4" r="1.6" stroke="currentColor" stroke-width="1.7"/><circle cx="16.5" cy="16.4" r="1.6" stroke="currentColor" stroke-width="1.7"/></svg>';
  var CART_GLYPH = '<svg viewBox="0 0 12 16" width="10" height="13" fill="none" aria-hidden="true"><path d="M1.6 5.6h8.8v8.8H1.6z" stroke="currentColor" stroke-width="1"/><path d="M1.6 5.6 6 2.6l4.4 3" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/></svg>';
  var DECSEP = (C.k17 === 'en') ? '.' : ',';
  function fmtGkg(g) { return g >= 1000 ? (g / 1000).toFixed(1).replace('.', DECSEP) + ' kg' : Math.round(g) + ' g'; }
  var STACK_T = C.k18;
  var BUTTER_T = C.k19;
  var CUBES_T = C.k20;

  /* ----- How-to-use content (localized) ----- */
  var HTU = {
    body: C.k21,
    tryLabel: C.k22,
    chips: [
      { label: C.k23, tip: C.k24, icon: ICON_COFFEE },
      { label: C.k25, tip: C.k26, icon: ICON_MATCHA },
      { label: C.k27, tip: C.k28, icon: ICON_CEREAL },
      { label: C.k29, tip: C.k30, icon: ICON_SMOOTHIE },
      { label: C.k31, tip: C.k32, icon: ICON_PANCAKE },
      { label: C.k33, tip: C.k34, icon: ICON_COOKING }
    ]
  };
  var SHIP_FREE_LABEL = C.k35;
  var SHIP_THRESHOLD_LABEL = C.k36;
  /* US free shipping is $75+ (only the 4-pack qualifies); EU is free from 2+ pouches */
  
  var FS_MIN_BAGS = C.k37;
  var COUNTRY_ISO = C.k38;
  function oatFlag(cc){ if(!cc || cc.length !== 2) return ''; return cc.toUpperCase().replace(/./g, function(c){ return String.fromCodePoint(127397 + c.charCodeAt(0)); }) + ' '; }

  /* ----- "Is OATENTIK for you?" accordion content (localized) ----- */
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var IFU = {
    heading: C.k39,
    sub: C.k40,
    items: [ C.k41, C.k42, C.k43, C.k44, C.k45 ]
  };

  function cloneNutritionCard() {
    var tpl = document.getElementById('oatentik-nutrition-card-template');
    if (!tpl) return null;
    var frag = document.createDocumentFragment();
    Array.prototype.slice.call(tpl.children).forEach(function (ch) { frag.appendChild(ch.cloneNode(true)); });
    return frag;
  }
  function clonePaymentIcons() {
    var tpl = document.getElementById('oatentik-payment-icons-template');
    return tpl ? tpl.content.cloneNode(true) : null;
  }
  function cloneCertRow() {
    var tpl = document.getElementById('oatentik-cert-row-template');
    return tpl ? tpl.content.cloneNode(true) : null;
  }

  /* ----- Nutrition CTA + Modal ----- */
  function injectNutritionButton() {
    if (document.querySelector('.oatentik-nutrition-link')) return true;
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    /* IM8 pattern: append a "View nutrition label" text link to the bottom of the
       "Quality and certificates" accordion body; clicking opens the modal. */
    var acc = info.querySelectorAll('.product__accordion details');
    if (!acc.length) acc = info.querySelectorAll('details');
    var host = null;
    for (var i = 0; i < acc.length; i++) {
      var sm = acc[i].querySelector('summary, .accordion__title, .summary__title');
      var txt = (sm ? sm.textContent : (acc[i].textContent || '')).toLowerCase();
      if (txt.indexOf('ingredient') !== -1 || txt.indexOf('sestavin') !== -1) { host = acc[i]; break; }
    }
    if (!host) host = acc[2] || acc[1] || acc[0];  /* Ingredients is the 3rd accordion (Is-for-you, How-to, Ingredients) */
    if (!host) return false;
    var content = host.querySelector('.accordion__content, .product__accordion-content, .rte');
    if (!content) {
      var sum = host.querySelector('summary');
      for (var j = 0; j < host.children.length; j++) { if (host.children[j] !== sum) { content = host.children[j]; break; } }
    }
    if (!content || content.querySelector('.oatentik-nutrition-link')) return true;
    var a = document.createElement('a');
    a.className = 'oatentik-nutrition-link';
    a.href = '#';
    a.setAttribute('role', 'button');
    a.setAttribute('aria-haspopup', 'dialog');
    a.innerHTML = ICON_DOC + '<span>' + BUTTON_LABEL + '</span>';
    a.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    content.appendChild(a);
    return true;
  }
  function injectModal() {
    if (document.getElementById('oatentik-nutrition-modal')) return;
    var tpl = document.getElementById('oatentik-nutrition-modal-template');
    if (!tpl) return;
    var node = tpl.content.cloneNode(true);
    var root = node.querySelector('.oatentik-nutrition-modal');
    root.id = 'oatentik-nutrition-modal';
    document.body.appendChild(node);
    var body = document.getElementById('oatentik-nutrition-modal-body');
    var card = cloneNutritionCard();
    if (body && card) body.appendChild(card);
    root.addEventListener('click', function (e) { if (e.target === root) closeModal(); });
    root.querySelector('.oatentik-nutrition-modal__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }
  function openModal() {
    injectModal();
    var m = document.getElementById('oatentik-nutrition-modal');
    if (m) { m.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  }
  function closeModal() {
    var m = document.getElementById('oatentik-nutrition-modal');
    if (m) { m.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  }

  /* ----- Inject Nutrition card into Ingredients accordion ----- */
  function injectIntoIngredients() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    var candidates = info.querySelectorAll('details, .product__accordion');
    var matched = false;
    candidates.forEach(function (d) {
      var summary = d.querySelector('summary, .accordion__header, .summary__title');
      var heading = summary ? (summary.textContent || '').trim().toLowerCase() : '';
      if (!/ingredient/i.test(heading)) return;
      var content = d.querySelector('.product__accordion-content, .accordion__content, .product__description, .rte');
      if (!content) {
        for (var i = 0; i < d.children.length; i++) {
          if (d.children[i] !== summary) { content = d.children[i]; break; }
        }
      }
      if (!content || content.querySelector('.oatentik-nutrition-card')) { matched = true; return; }
      var card = cloneNutritionCard();
      if (!card) return;
      content.innerHTML = '';
      content.appendChild(card);
      matched = true;
    });
    return matched;
  }

  /* ----- Quantity picker decoration ----- */
  function pickPackLiters(title, idx) {
    var t = (title || '').toLowerCase();
    if (/4\s*bag|3200/.test(t)) return 32;
    if (/2\s*bag|1600/.test(t)) return 16;
    if (/1\s*bag|800/.test(t)) return 8;
    /* fallback: assume sequential 8L/16L/32L by index */
    return [8, 16, 32][idx] || 8;
  }
  function decoratePackPicker() {
    var pickers = document.querySelectorAll('.product-form__input--pill, fieldset.product-form__input');
    if (!pickers.length || !variants.length) return false;
    pickers.forEach(function (fs) {
      /* Add "Choose quantity:" label */
      var qlbl = fs.querySelector('.oatentik-quantity-label');
      if (!qlbl) {
        var legend = fs.querySelector('legend');
        qlbl = document.createElement('div');
        qlbl.className = 'oatentik-quantity-label';
        if (legend) legend.insertAdjacentElement('afterend', qlbl);
        else fs.insertBefore(qlbl, fs.firstChild);
      }
      qlbl.textContent = (PACK_LABEL || '').replace(/\s*[:：]\s*$/, '');
      var labels = fs.querySelectorAll('input[type="radio"] + label, label.input--pill');
      if (!labels.length) labels = fs.querySelectorAll('label');
      labels.forEach(function (label, idx) {
        if (label.dataset.oatentikDecorated === '1') return;
        var v = variants[idx];
        if (!v) return;
        label.dataset.oatentikDecorated = '1';
        var price = v.price_money || '';
        var was = v.compare_money || '';
        var fromP = (v.has_sub && v.from_money) ? v.from_money : '';
        var liters = pickPackLiters(v.title, idx);
        var count = liters ? Math.max(1, Math.round(liters / 8)) : ([1, 2, 4][idx] || 1);
        var iconUrl = PACK_ICONS[String(count)] || '';
        var iconW = { '1': 18, '2': 25, '4': 28 }[String(count)] || 28;
        var icons = iconUrl ? '<div class="oatentik-pack-decor__icons"><img src="' + iconUrl + '" alt="" width="' + iconW + '" height="30" loading="lazy"></div>' : '';
        var html = '';
        if (idx === 1) html += '<span class="oatentik-pack-badge">' + POPULAR_LABEL + '</span>';
        else if (idx === 2) html += '<span class="oatentik-pack-badge oatentik-pack-badge--value">' + BESTVALUE_LABEL + '</span>';
        html += '<div class="oatentik-pack-decor">' +
                  icons +
                  '<div class="oatentik-pack-decor__top">' + (liters ? (count + ' × 800 g') : v.title) + '</div>' +
                  (liters ? '<div class="oatentik-pack-decor__makes">= ' + liters + ' L</div>' : '') +
                  '<div class="oatentik-pack-decor__price">' +
                    '<span class="oatentik-pack-decor__price-main">' + oatSmallCents(price) + '</span>' +
                    (was ? '<span class="oatentik-pack-decor__price-was">' + oatSmallCents(was) + '</span>' : '') +
                  '</div>' +
                  (fromP ? '<div class="oatentik-pack-decor__from">' + FROM_LABEL + ' ' + oatSmallCents(fromP) + '</div>' : '') +
                  '<div class="oatentik-pack-decor__save" hidden></div>' +
                  '<div class="oatentik-pack-decor__perl"></div>' +
                  (count >= FS_MIN_BAGS ? '<div class="oatentik-pack-decor__ship">' + ICON_SHIP + '<span>' + SHIP_FREE_LABEL + '</span></div>' : '') +
                '</div>';
        /* Replace inner label text */
        label.innerHTML = html;
        label.dataset.vidx = String(idx);
        label.dataset.otPerl  = v.perl_ot_money ? (v.perl_ot_money + ' ' + PERL_LABEL) : '';
        label.dataset.subPerl = (v.has_sub && v.perl_sub_money) ? (v.perl_sub_money + ' ' + PERL_LABEL) : (label.dataset.otPerl || '');
        label.dataset.otSave  = v.save_ot_money ? (SAVE_LABEL + ' ' + v.save_ot_money) : '';
        label.dataset.subSave = (v.has_sub && v.save_sub_money) ? (SAVE_LABEL + ' ' + v.save_sub_money) : '';
      });
    });
    syncPackModePricing();
    bindPackModeSync();
    return true;
  }
  function activePlanInput() {
    return document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]') || document.querySelector('input[name="selling_plan"]');
  }
  /* ----- Native purchase-option widget (replaces Seal's on-page UI) ----- */
  function oatNsubWidget() { return document.querySelector('[data-oat-nsub]'); }
  function oatNsubActive() {
    var w = oatNsubWidget();
    if (w) { var r = w.querySelector('input[name="oat-nsub-mode"][value="sub"]'); return !!(r && r.checked); }
    return !!document.querySelector('.sls-option-container[data-selling-plan-group].sls-active');
  }
  function oatNsubPlanId() {
    var w = oatNsubWidget();
    if (!w) { var sp = activePlanInput(); return (sp && sp.value) ? String(sp.value).trim() : ''; }
    if (!oatNsubActive()) return '';
    var sel = w.querySelector('[data-nsub-plan]');
    return sel ? String(sel.value) : '';
  }
  function oatNsubEnsureInput() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var inp = form.querySelector('input[name="selling_plan"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'selling_plan'; inp.value = '';
      form.appendChild(inp);
    }
    return inp;
  }
  function oatPlanFor(v, planId) {
    if (!v || !v.plans || !planId) return null;
    for (var i = 0; i < v.plans.length; i++) { if (String(v.plans[i].id) === String(planId)) return v.plans[i]; }
    return null;
  }
  function updateNativeSub() {
    var w = oatNsubWidget(); if (!w) return;
    var v = currentVariant(); if (!v) return;
    var otP = w.querySelector('[data-nsub-ot-price]'), otW = w.querySelector('[data-nsub-ot-was]');
    oatSetMoney(otP, v.price_money || '');
    if (otW) { if (v.compare_money) { oatSetMoney(otW, v.compare_money); otW.hidden = false; } else { otW.hidden = true; } }
    var sel = w.querySelector('[data-nsub-plan]');
    var planId = sel ? String(sel.value) : '';
    var plan = oatPlanFor(v, planId);
    var subPrice = plan ? plan.price_money : (v.from_money || '');
    var sP = w.querySelector('[data-nsub-sub-price]'), sW = w.querySelector('[data-nsub-sub-was]');
    oatSetMoney(sP, subPrice || '');
    /* anchor the strike to the ONE-TIME price so the "save 20%" pill is verifiably
       true (striking the compare-at 32,00 under 19,20 implied 40%, incoherent) */
    if (sW) { if (v.price_money) { oatSetMoney(sW, v.price_money); sW.hidden = false; } else { sW.hidden = true; } }
    var pill = w.querySelector('[data-nsub-pill]');
    if (pill && sel) {
      var opt = sel.options[sel.selectedIndex];
      var pct = opt ? (opt.getAttribute('data-pct') || '') : '';
      var tpl = pill.getAttribute('data-tpl') || '';
      if (pct && tpl) {
        var ptxt = tpl.replace('[pct]', pct);
        if (pill.textContent !== ptxt) pill.textContent = ptxt;
      }
    }
    var plans = w.querySelector('.oatentik-nsub__plans');
    if (plans) plans.hidden = !oatNsubActive();
    w.querySelectorAll('.oatentik-nsub__opt').forEach(function (o) {
      var r = o.querySelector('input[type="radio"]');
      o.classList.toggle('is-active', !!(r && r.checked));
    });
  }
  function oatNsubApply() {
    var inp = oatNsubEnsureInput(); if (!inp) return;
    var want = oatNsubActive() ? oatNsubPlanId() : '';
    if (String(inp.value || '') !== want) {
      inp.value = want;
      try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
    updateNativeSub();
    try { updateAtcPrice(); } catch (e) {}
    try { updateCardPrices(); } catch (e) {}
    try { syncPackModePricing(); } catch (e) {}
    try { updateCalcSummary(); } catch (e) {}
    try { injectSubPayNote(); } catch (e) {}
    try { updateStickyAtc(); } catch (e) {}
  }
  function initNativeSub() {
    var tpl = document.getElementById('oatentik-native-sub-template');
    if (!tpl) return; /* product has no selling plans, keep whatever exists */
    if (oatNsubWidget()) return;
    var anchor = document.querySelector('.sealsubs-target-element') || document.querySelector('.sls-purchase-options-container');
    var parent = null, before = null;
    if (anchor && anchor.parentNode) { parent = anchor.parentNode; before = anchor; }
    else {
      var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
      if (fs && fs.parentNode) { parent = fs.parentNode; before = fs.nextSibling; }
    }
    if (!parent) return;
    parent.insertBefore(tpl.content.cloneNode(true), before);
    document.documentElement.classList.add('oat-nsub-on');
    var w = oatNsubWidget(); if (!w) return;
    oatNsubEnsureInput();
    w.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'oat-nsub-mode' || e.target.hasAttribute('data-nsub-plan'))) {
        oatNsubApply();
        if (e.target.name === 'oat-nsub-mode') {
          oatPublish(oatNsubActive() ? 'oat_pdp_mode_subscribe' : 'oat_pdp_mode_onetime', {});
        }
      }
    });
    /* keep widget prices in step with variant/pack changes */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]') && !w.contains(e.target)) {
        setTimeout(updateNativeSub, 90);
      }
    });
    updateNativeSub();
  }
  function syncPackModePricing() {
    var sp = activePlanInput();
    var planId = (sp && sp.value) ? String(sp.value).trim() : '';
    document.querySelectorAll('label[data-oatentik-decorated="1"]').forEach(function (label) {
      var perlEl = label.querySelector('.oatentik-pack-decor__perl');
      var saveEl = label.querySelector('.oatentik-pack-decor__save');
      var perl = label.dataset.otPerl || '';
      var save = label.dataset.otSave || '';
      if (planId) {
        var v = variants[+label.dataset.vidx];
        var plan = null;
        if (v && v.plans) { for (var i = 0; i < v.plans.length; i++) { if (String(v.plans[i].id) === planId) { plan = v.plans[i]; break; } } }
        if (plan) {
          perl = plan.perl_money ? (plan.perl_money + ' ' + PERL_LABEL) : '';
          save = plan.save_money ? (SAVE_LABEL + ' ' + plan.save_money) : '';
        } else {
          perl = label.dataset.subPerl || perl;
          save = label.dataset.subSave || save;
        }
      }
      if (perlEl) perlEl.textContent = perl;
      if (saveEl) {
        if (save) { saveEl.textContent = save; saveEl.hidden = false; } else { saveEl.textContent = ''; saveEl.hidden = true; }
      }
    });
  }
  function bindPackModeSync() {
    if (window.__oatPackModeBound) return;
    window.__oatPackModeBound = true;
    document.addEventListener('change', function () { setTimeout(function () { syncPackModePricing(); if (window.requestAnimationFrame) requestAnimationFrame(updateStickyAtc); else updateStickyAtc(); }, 80); }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sls-option-container, .seal-col-radio')) { setTimeout(syncPackModePricing, 120); }
    }, true);
    var lastPlanSeen = null;
    /* With the native widget the selling_plan input is only written by our own
       handlers (which sync directly), so this is just a slow safety net —
       was a 250ms hot loop when Seal's script owned the input (INP). */
    setInterval(function () {
      var sp = activePlanInput();
      var pid = (sp && sp.value) ? String(sp.value).trim() : '';
      if (pid !== lastPlanSeen) { lastPlanSeen = pid; syncPackModePricing(); updateStickyAtc(); }
      if (!document.querySelector('.oat-sticky')) injectStickyAtc();
    }, 1000);
    document.addEventListener('variant:change', function () { setTimeout(syncPackModePricing, 60); });
  }

  /* ----- Cert row (immediately AFTER bullets) ----- */
  function injectCertRow() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    if (info.querySelector('.oatentik-cert-row')) return true;
    var bullets = info.querySelector('.oatentik-trust-bullets');
    var row = cloneCertRow();
    if (!row) return false;
    if (bullets && bullets.parentNode) {
      bullets.parentNode.insertBefore(row, bullets.nextSibling);
      return true;
    }
    /* Fallback: before buy buttons if bullets missing */
    var buyButtons = info.querySelector('.product-form__buttons, .product-form');
    if (!buyButtons) return false;
    buyButtons.parentNode.insertBefore(row, buyButtons);
    return true;
  }

  /* ----- Ships in 24h + delivery + payment icons (below ATC) ----- */
  function deliveryRange() {
    var now = new Date();
    var d1 = new Date(now.getTime() + 4 * 86400000);
    var d2 = new Date(now.getTime() + 8 * 86400000);
    var lang = document.documentElement.lang || 'en';
    var fmtFull = function (d) {
      try { return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); }
      catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
    };
    var fmtDay = function (d) {
      try { return d.toLocaleDateString(lang, { day: 'numeric' }); }
      catch (e) { return '' + d.getDate(); }
    };
    /* same month → don't repeat the month name ("Jun 21–25" not "Jun 21 – Jun 25") */
    var end = (d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) ? fmtDay(d2) : fmtFull(d2);
    return fmtFull(d1) + '–' + end;
  }
  /* ----- Gallery prev/next overlay (clicks next/prev thumbnail) ----- */
  var CHEVRON_NEXT = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_PREV = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function activeThumbIndex() {
    var thumbList = document.querySelector('.thumbnail-list, ul.thumbnail-list');
    if (!thumbList) return null;
    var items = thumbList.querySelectorAll('li, .thumbnail-list__item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('[aria-current="true"], .thumbnail--active, .thumbnail.is-active')) {
        return { list: thumbList, items: items, idx: i };
      }
    }
    return items.length ? { list: thumbList, items: items, idx: 0 } : null;
  }
  function updateGalleryArrowVisibility() {
    var state = activeThumbIndex();
    if (!state) return;
    var prev = document.querySelector('.oatentik-gallery-arrow--prev');
    var next = document.querySelector('.oatentik-gallery-arrow--next');
    var atStart = state.idx === 0;
    var atEnd = state.idx === state.items.length - 1;
    if (prev) {
      prev.style.opacity = atStart ? '0' : '1';
      prev.style.pointerEvents = atStart ? 'none' : 'auto';
    }
    if (next) {
      next.style.opacity = atEnd ? '0' : '1';
      next.style.pointerEvents = atEnd ? 'none' : 'auto';
    }
  }
  function advanceGallery(dir) {
    var state = activeThumbIndex();
    if (!state) return;
    var nextIdx = state.idx + dir;
    if (nextIdx < 0 || nextIdx >= state.items.length) return;
    var btn = state.items[nextIdx].querySelector('button, a, .thumbnail, [role="button"]');
    if (btn) {
      btn.click();
      try { state.items[nextIdx].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' }); } catch (e) {}
      setTimeout(updateGalleryArrowVisibility, 80);
    }
  }
  function positionGalleryArrows() {
    var gallery = document.querySelector('media-gallery') || document.querySelector('.product__media-gallery') || document.querySelector('.product__media-wrapper');
    var list = document.querySelector('.product__media-list') || document.querySelector('.product-media-container');
    var arrows = document.querySelectorAll('.oatentik-gallery-arrow');
    if (!gallery || !list || !arrows.length) return;
    var gr = gallery.getBoundingClientRect(), lr = list.getBoundingClientRect();
    var center = (lr.top - gr.top) + (lr.height / 2);
    for (var i = 0; i < arrows.length; i++) { arrows[i].style.top = center + 'px'; }
  }

  function injectGalleryArrows() {
    var anchor = document.querySelector('media-gallery') || document.querySelector('.product__media-gallery') || document.querySelector('.product__media-wrapper') || document.querySelector('.product__media-list');
    if (!anchor) return false;
    if (document.querySelector('.oatentik-gallery-arrow')) return true;
    var thumbCount = document.querySelectorAll('.thumbnail-list li, .thumbnail-list__item').length;
    if (thumbCount < 2) return true; /* No point in arrows if single media */

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'oatentik-gallery-arrow oatentik-gallery-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON_NEXT;
    next.addEventListener('click', function (e) { e.preventDefault(); advanceGallery(1); });

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'oatentik-gallery-arrow oatentik-gallery-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON_PREV;
    prev.addEventListener('click', function (e) { e.preventDefault(); advanceGallery(-1); });

    anchor.appendChild(prev);
    anchor.appendChild(next);
    positionGalleryArrows();
    setTimeout(positionGalleryArrows, 200);
    setTimeout(positionGalleryArrows, 600);
    window.addEventListener('resize', positionGalleryArrows);

    /* Sync visibility on direct thumbnail clicks too */
    var thumbList = document.querySelector('.thumbnail-list, ul.thumbnail-list');
    if (thumbList) {
      thumbList.addEventListener('click', function () {
        setTimeout(updateGalleryArrowVisibility, 80);
      });
    }
    setTimeout(updateGalleryArrowVisibility, 100);
    return true;
  }

  /* ----- 30-day journey slider (after Quality and certificates accordion) ----- */
  function injectJourneySlider() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    if (info.querySelector('.oatentik-journey-slider')) return true;
    var accordions = info.querySelectorAll('details, .product__accordion');
    var target = null;
    accordions.forEach(function (d) {
      var summary = d.querySelector('summary, .accordion__header, .summary__title');
      var text = summary ? (summary.textContent || '').toLowerCase() : '';
      if (/quality|certificate|certifik/i.test(text)) target = d;
    });
    if (!target && accordions.length) target = accordions[accordions.length - 1];
    if (!target) return false;
    var tpl = document.getElementById('oatentik-journey-template');
    if (!tpl) return false;
    var node = tpl.content.cloneNode(true);
    target.parentNode.insertBefore(node, target.nextSibling);

    /* Wire up nav arrows */
    var slider = info.querySelector('.oatentik-journey-slider');
    var track = slider && slider.querySelector('.oatentik-journey-slider__track');
    if (!slider || !track) return true;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'oatentik-journey-slider__nav oatentik-journey-slider__nav--prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = CHEVRON_PREV;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'oatentik-journey-slider__nav oatentik-journey-slider__nav--next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = CHEVRON_NEXT;

    slider.appendChild(prev);
    slider.appendChild(next);

    function scrollOne(dir) {
      var card = track.querySelector('.oatentik-journey-slider__card');
      var dist = card ? card.offsetWidth + 10 : 200;
      track.scrollBy({ left: dist * dir, behavior: 'smooth' });
    }
    function updateNav() {
      prev.classList.toggle('is-visible', track.scrollLeft > 5);
      next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 5);
    }
    prev.addEventListener('click', function () { scrollOne(-1); });
    next.addEventListener('click', function () { scrollOne(1); });
    track.addEventListener('scroll', updateNav, { passive: true });
    setTimeout(updateNav, 50);
    return true;
  }

  function injectTrustLine() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    if (info.querySelector('.oatentik-trust-line')) return true;
    var buy = info.querySelector('.product-form__buttons');
    if (!buy) return false;
    var line = document.createElement('div');
    line.className = 'oatentik-trust-line';
    line.innerHTML = '<span class="oatentik-trust-line__grp">' + ICON_TRUCK + '<strong>' + SHIPS_LABEL + '</strong></span>' +
                     '<span class="oatentik-trust-line__sep">•</span>' +
                     '<span class="oatentik-trust-line__grp"><span class="oatentik-trust-line__dl">' + DELIVERY_LABEL + ' </span><span class="oatentik-trust-line__dls">' + DELIVERY_SHORT + ' ~</span><strong>' + deliveryRange() + '</strong></span>';
    buy.parentNode.insertBefore(line, buy.nextSibling);
    var pay = document.createElement('div');
    pay.className = 'oatentik-payment-row';
    var icons = clonePaymentIcons();
    if (icons) pay.appendChild(icons);
    line.parentNode.insertBefore(pay, line.nextSibling);
    return true;
  }

  /* ----- Free-gift selector (above Add to cart) -----
     GIFT_LIVE stays false until the store-level free-gift automatic discount
     is created at publish. While false the selector is visual only (no cart
     writes) so free gifts can't leak onto the live store beforehand. */
  var GIFT_LIVE = true;
  function injectGifts() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    if (info.querySelector('.oatentik-gifts')) return true;
    var buy = info.querySelector('.product-form__buttons');
    var tpl = document.getElementById('oatentik-gifts-template');
    if (!buy || !tpl) return false;
    buy.parentNode.insertBefore(tpl.content.cloneNode(true), buy);
    var wrap = info.querySelector('.oatentik-gifts');
    if (!wrap) return true;
    /* Gifts stay preselected (ticked) for everyone, fully deselectable.
       data-returning is left on the element so the free-gift discount can be
       capped to first order / once-per-customer at publish to avoid flooding. */
    /* Checkboxes are a PREFERENCE only (no live cart writes). The ticked gifts
       ride along into the cart on Add-to-cart via wireGiftRideAlong(), so they
       land together with the product and the BXGY discount can zero them. */
    return true;
  }

  /* ----- Ticked gifts ride along on Add-to-cart (added with the product so the BXGY zeroes them; still removable from cart) ----- */
  function wireGiftRideAlong() {
    if (window.__oatGiftRideWired) return;
    window.__oatGiftRideWired = true;
    document.addEventListener('submit', function (e) {
      if (!GIFT_LIVE) return;
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.__oatGiftDone) { form.__oatGiftDone = false; return; }
      var checks = document.querySelectorAll('.oatentik-gift__check:checked');
      var items = [];
      for (var i = 0; i < checks.length; i++) {
        var lab = checks[i].closest('.oatentik-gift');
        var id = lab && lab.getAttribute('data-variant-id');
        if (id) items.push({ id: Number(id), quantity: 1, properties: { _gift: 'true' } });
      }
      if (!items.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
          var toAdd = items.filter(function (it) { return !have[it.id]; });
          if (!toAdd.length) return null;
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: toAdd }) });
        })
        .catch(function () {})
        .then(function () {
          form.__oatGiftDone = true;
          if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        });
    }, true);
  }

  /* ----- Travel Tin unlocks only when 2+ pouches are selected (matches the BxGy).
     The pack picker is client-side, so this is re-evaluated on every pack change;
     the server renders the tin locked by default. ----- */
  function oatSelectedPouches() {
    var idx = -1, i;
    var idInput = document.querySelector('.product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    var vid = idInput && idInput.value;
    if (vid && variants && variants.length) {
      for (i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) { idx = i; break; } }
    }
    if (idx < 0) {
      var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
      if (fs) { var rs = fs.querySelectorAll('input[type="radio"]'); for (i = 0; i < rs.length; i++) { if (rs[i].checked) { idx = i; break; } } }
    }
    if (idx < 0) idx = 0;
    var v = (variants && variants[idx]) || null;
    var liters = 0;
    try { if (typeof pickPackLiters === 'function') liters = pickPackLiters(v && v.title, idx); } catch (e) {}
    return liters ? Math.max(1, Math.round(liters / 8)) : ([1, 2, 4][idx] || 1);
  }
  var __oatTinPrevUnlocked = null;
  function syncTinLock() {
    var tin = document.querySelector('.oatentik-gift[data-gift-tin]');
    if (!tin) return;
    var chk = tin.querySelector('.oatentik-gift__check');
    var unlocked = tin.getAttribute('data-server-unlocked') === '1' || oatSelectedPouches() >= 2;
    if (unlocked) {
      tin.classList.remove('oatentik-gift--locked');
      if (chk) {
        chk.disabled = false;
        /* default-tick when it first becomes available, unless the shopper opted out */
        if (__oatTinPrevUnlocked !== true && !tin.__oatUserUnticked) chk.checked = true;
      }
    } else {
      tin.classList.add('oatentik-gift--locked');
      if (chk) { chk.checked = false; chk.disabled = true; }
    }
    __oatTinPrevUnlocked = unlocked;
  }
  /* remember an explicit untick so we don't re-tick the tin on the next sync */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('oatentik-gift__check')) {
      var lab = t.closest && t.closest('.oatentik-gift[data-gift-tin]');
      if (lab) lab.__oatUserUnticked = !t.checked;
    }
  });

  /* ----- Tidy the Seal label (drop trailing " :" so it matches the other headings) ----- */
  function polishSeal() {
    var lbl = document.querySelector('.sls-purchase-options-label');
    if (lbl && !lbl.__oatClean) {
      lbl.__oatClean = 1;
      lbl.textContent = (lbl.textContent || '').replace(/\s*[:：]\s*$/, '').trim();
    }
  }
  function injectSubPayNote() {
    var note = document.querySelector('.oatentik-sub-paynote');
    if (!note) {
      var anchor = document.querySelector('[data-oat-nsub]') || document.querySelector('.sls-purchase-options-container') || document.querySelector('.sealsubs-target-element');
      if (!anchor || !anchor.parentNode) return;
      note = document.createElement('p');
      note.className = 'oatentik-sub-paynote';
      note.textContent = SUB_PAY_NOTE;
      anchor.parentNode.insertBefore(note, anchor.nextSibling);
    }
    /* Only show when a subscription option is selected, it's just friction on one-time. */
    var subActive = oatNsubActive();
    note.setAttribute('style', "font-family:'Roboto',sans-serif!important;font-size:11.5px!important;font-weight:400!important;line-height:1.5!important;color:rgba(40,40,40,0.82)!important;margin:0.6rem 0 0!important;display:" + (subActive ? 'block' : 'none') + "!important");
  }
  /* ----- Pack & savings calculator (expandable, above quantity cards) ----- */
  var CALC_COPY = {
    wks: C.k46,
    sel: C.k47,
    recNew: C.k48,
    recsubNew: C.k49,
    recRet: C.k50,
    recsubRet: C.k51,
    subPriceLine: C.k55,
    off: C.k52
  };
  var SUB_PAY_NOTE = C.k53;
  function oatPublish(n, d) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {} }
  function injectCalc() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    if (info.querySelector('.oatentik-calc')) return true;
    var fs = info.querySelector('fieldset.product-form__input, .product-form__input--pill');
    var tpl = document.getElementById('oatentik-calc-template');
    if (!fs || !tpl) return false;
    fs.parentNode.insertBefore(tpl.content.cloneNode(true), fs);
    var root = info.querySelector('.oatentik-calc');
    if (root) wireCalc(root);
    return true;
  }
  function wireCalc(root) {
    var trigger = root.querySelector('.oatentik-calc__trigger');
    var panel = root.querySelector('.oatentik-calc__panel');
    var sL = root.querySelector('.oatentik-calc__l');
    var chips = [].slice.call(root.querySelectorAll('.oatentik-calc__chip'));
    var apply = root.querySelector('.oatentik-calc__apply');
    var isRet = root.getAttribute('data-returning') === 'true';
    var overlay = root.querySelector('.oatentik-calc__overlay');
    var calcClose = root.querySelector('.oatentik-calc__close');
    function openCalc() {
      if (overlay && overlay.parentElement !== document.body) { document.body.appendChild(overlay); }
      if (overlay) overlay.hidden = false;
      document.documentElement.classList.add('oat-calc-lock');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeCalc() {
      if (overlay) overlay.hidden = true;
      document.documentElement.classList.remove('oat-calc-lock');
      trigger.setAttribute('aria-expanded', 'false');
    }
    if (overlay) {
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeCalc(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeCalc(); });
    }
    if (calcClose) calcClose.addEventListener('click', closeCalc);
    var packs = (window.oatentikVariants || []).map(function (v, i) {
      var liters = pickPackLiters(v.title, i) || [8, 16, 32][i] || 8;
      return { n: v.title, L: liters, once: (v.price_money || ''), sub: (v.from_money || v.price_money || ''), idx: i, perlOnce: (v.perl_ot_money || ''), perlSub: (v.perl_sub_money || v.perl_ot_money || '') };
    });
    if (!packs.length) packs = [{ n: '1 bag', L: 8, once: '', sub: '', idx: 0 }, { n: '2 bags', L: 16, once: '', sub: '', idx: 1 }, { n: '4 bags', L: 32, once: '', sub: '', idx: 2 }];
    function pick(mo) { return mo <= 10 ? 0 : (mo <= 20 ? 1 : 2); }
    function interval(lw) { var o = [6, 4, 2]; for (var i = 0; i < o.length; i++) { if (o[i] <= lw) return o[i]; } return 2; }
    var state = { pi: 1, iv: 4 };
    function render() {
      var L = +sL.value, mo = L * 4.345;
      var pi = Math.min(pick(mo), packs.length - 1), pk = packs[pi];
      var lw = pk.L / L, iv = interval(lw);
      var cartonsYr = Math.round(L * 52);
      state.pi = pi; state.iv = iv;
      var kg = cartonsYr;            /* 1 L carton ~ 1 kg */
      var fatG = cartonsYr * 9;      /* 1.5 - 0.6 g/100ml = 9 g/L less fat (conservative low-end ref) */
      var sugarG = cartonsYr * 29;   /* 5 - 2.1 g/100ml = 29 g/L less sugar (typical ~5 g, e.g. Aldi) */
      panel.querySelector('.oatentik-calc__lo').textContent = L + ' L';
      var lastsEl = panel.querySelector('.oatentik-calc__lasts'); if (lastsEl) lastsEl.textContent = Math.round(lw);
      panel.querySelector('.oatentik-calc__cartons').textContent = cartonsYr;
      var kgEl = panel.querySelector('.oatentik-calc__kg'); if (kgEl) kgEl.textContent = kg;
      var fatEl = panel.querySelector('.oatentik-calc__fat'); if (fatEl) fatEl.textContent = fmtGkg(fatG);
      var sugEl = panel.querySelector('.oatentik-calc__sugar'); if (sugEl) sugEl.textContent = fmtGkg(sugarG);
      var pileEl = panel.querySelector('.oatentik-calc__pile');
      if (pileEl) { var cap = Math.min(cartonsYr, 120), ph = ''; for (var pc = 0; pc < cap; pc++) { ph += CART_GLYPH; } if (cartonsYr > cap) { ph += '<span class="oatentik-calc__pile-more">+' + (cartonsYr - cap) + '</span>'; } pileEl.innerHTML = ph; }
      var floors = Math.max(1, Math.round(cartonsYr * 0.195 / 3));
      var stackEl = panel.querySelector('.oatentik-calc__stack'); if (stackEl) stackEl.innerHTML = STACK_T.replace('{n}', '<b>' + floors + '</b>');
      var butEl = panel.querySelector('.oatentik-calc__butter'); if (butEl) butEl.innerHTML = BUTTER_T.replace('{n}', '<b>' + Math.round(fatG / 250) + '</b>');
      var cubEl = panel.querySelector('.oatentik-calc__cubes'); if (cubEl) cubEl.innerHTML = CUBES_T.replace('{n}', '<b>' + Math.round(sugarG / 4).toLocaleString() + '</b>');
      var recEl = panel.querySelector('.oatentik-calc__rec');
      var subEl = panel.querySelector('.oatentik-calc__recsub');
      if (isRet) {
        var perlR = pk.perlSub ? ' <span class="oatentik-calc__perl" style="opacity:.6;font-weight:600;white-space:nowrap">· ' + pk.perlSub + ' ' + PERL_LABEL + '</span>' : '';
        recEl.innerHTML = CALC_COPY.recRet.replace('{pack}', '<b>' + pk.n + '</b>').replace('{price}', '<b>' + pk.sub + '</b>') + perlR + ' <span class="oatentik-calc__off">' + CALC_COPY.off + '</span>';
        subEl.textContent = CALC_COPY.recsubRet.replace('{iv}', iv);
      } else {
        var perlN = pk.perlOnce ? ' <span class="oatentik-calc__perl" style="opacity:.6;font-weight:600;white-space:nowrap">· ' + pk.perlOnce + ' ' + PERL_LABEL + '</span>' : '';
        recEl.innerHTML = CALC_COPY.recNew.replace('{pack}', '<b>' + pk.n + '</b>').replace('{price}', '<b>' + pk.once + '</b>') + perlN;
        var subLineN = (pk.sub && CALC_COPY.subPriceLine) ? CALC_COPY.subPriceLine.replace('{price}', '<b>' + pk.sub + '</b>').replace('{perl}', pk.perlSub ? '<b>' + pk.perlSub + ' ' + PERL_LABEL + '</b>' : '') : '';
        subEl.innerHTML = CALC_COPY.recsubNew + subLineN;
      }
    }
    function syncChips(L) { chips.forEach(function (c) { var on = (+c.dataset.l === L); c.classList.toggle('on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    chips.forEach(function (c) { c.addEventListener('click', function () { sL.value = c.dataset.l; syncChips(+c.dataset.l); render(); }); });
    sL.addEventListener('input', function () { syncChips(+sL.value); render(); });
    trigger.addEventListener('click', function () {
      openCalc();
      if (!window.__oatCalcOpenTracked) {
        window.__oatCalcOpenTracked = true;
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'oat_calc_open', customer_type: isRet ? 'returning' : 'new' }); } catch (e) {}
        oatPublish('oat_calc_open', { customer_type: isRet ? 'returning' : 'new' });
      }
    });
    apply.addEventListener('click', function () {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'oat_calc_apply', customer_type: isRet ? 'returning' : 'new', pack_index: state.pi }); } catch (e) {}
      oatPublish('oat_calc_apply', { customer_type: isRet ? 'returning' : 'new', pack_index: state.pi });
      selectPack(state.pi);
      if (isRet) { trySubscribe(state.iv); } else { trySelectOneTime(); }
      closeCalc();
      trigger.classList.add('is-selected');
      updateCalcSummary();
      var atc = document.querySelector('.product-form__buttons');
      if (atc) { try { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
    });
    syncChips(4); render();
  }
  function selectPack(pi) {
    var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
    if (!fs) return;
    var radios = fs.querySelectorAll('input[type="radio"]');
    if (radios[pi]) {
      try { radios[pi].click(); } catch (e) {}
      var lbl = radios[pi].nextElementSibling;
      if (lbl && lbl.tagName === 'LABEL') { lbl.classList.add('oatentik-pack-pulse'); setTimeout(function () { lbl.classList.remove('oatentik-pack-pulse'); }, 1400); }
    }
  }
  function trySubscribe(iv) {
    try {
      var w = oatNsubWidget();
      if (w) {
        var r = w.querySelector('input[name="oat-nsub-mode"][value="sub"]');
        if (r && !r.checked) { r.checked = true; }
        var sel = w.querySelector('[data-nsub-plan]');
        if (sel && iv) {
          for (var j = 0; j < sel.options.length; j++) {
            if (String(sel.options[j].getAttribute('data-weeks')) === String(iv)) { sel.selectedIndex = j; break; }
          }
        }
        oatNsubApply();
        return;
      }
      var opts = document.querySelectorAll('.sls-option-container');
      if (opts.length > 1) {
        var sub = opts[1];
        var r = sub.querySelector('input[type="radio"]');
        if (r) { r.click(); } else { var fl = sub.querySelector('.sls-selling-plan-group-first-line'); if (fl) fl.click(); }
        var sel = sub.querySelector('select');
        if (sel) { for (var i = 0; i < sel.options.length; i++) { if ((sel.options[i].text || '').indexOf(String(iv)) > -1) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); break; } } }
      }
    } catch (e) {}
  }
  function trySelectOneTime() {
    try {
      var w = oatNsubWidget();
      if (w) {
        var r = w.querySelector('input[name="oat-nsub-mode"][value="onetime"]');
        if (r && !r.checked) { r.checked = true; }
        oatNsubApply();
        return;
      }
      var opts = document.querySelectorAll('.sls-option-container');
      if (opts.length) {
        var r = opts[0].querySelector('input[type="radio"]');
        if (r) { r.click(); } else { var fl = opts[0].querySelector('.sls-selling-plan-group-first-line'); if (fl) fl.click(); }
      }
    } catch (e) {}
  }

  function buildOrderBox() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info || info.querySelector('.oatentik-order-box')) return;
    var picker = info.querySelector('variant-radios, variant-selects, fieldset.product-form__input, .product-form__input--pill');
    var form = info.querySelector('product-form, .product-form');
    if (!picker || !form) return;
    function topChild(el) { while (el && el.parentElement && el.parentElement !== info) { el = el.parentElement; } return (el && el.parentElement === info) ? el : null; }
    var startEl = topChild(picker), endEl = topChild(form);
    if (!startEl || !endEl) return;
    if (startEl !== endEl && (startEl.compareDocumentPosition(endEl) & Node.DOCUMENT_POSITION_PRECEDING)) { var t = startEl; startEl = endEl; endEl = t; }
    var box = document.createElement('div');
    box.className = 'oatentik-order-box';
    startEl.parentNode.insertBefore(box, startEl);
    var node = startEl, guard = 0;
    while (node && guard < 40) {
      var next = node.nextSibling;
      box.appendChild(node);
      if (node === endEl) break;
      node = next; guard++;
    }
  }

  var ATC_BASE = null;
  function updateAtcPrice() {
    if (!variants.length) return;
    var btn = document.querySelector('.product-form__submit');
    if (!btn) return;
    var span = btn.querySelector('.product-form__submit-text') || btn.querySelector('span');
    if (!span) return;
    if (ATC_BASE === null) { ATC_BASE = (span.textContent || 'Add to cart').split('·')[0].trim() || 'Add to cart'; }
    var vid = null, idInput = document.querySelector('.product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idInput) vid = idInput.value;
    var v = null, i;
    for (i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) { v = variants[i]; break; } }
    if (!v) { var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill'); if (fs) { var rs = fs.querySelectorAll('input[type="radio"]'); for (i = 0; i < rs.length; i++) { if (rs[i].checked) { v = variants[i]; break; } } } }
    if (!v) v = variants[0];
    if (v.available === false) return;
    var subActive = oatNsubActive();
    var plan = subActive ? oatPlanFor(v, oatNsubPlanId()) : null;
    var price = subActive ? ((plan && plan.price_money) || v.from_money || v.price_money) : v.price_money;
    /* Button shows only the localized label — the price lives in the
       purchase-option box directly above; appending "· price" here overflowed
       the CTA edge-to-edge in long locales (HU/DE). */
    if (span.textContent !== ATC_BASE) span.textContent = ATC_BASE;
    watchAtc();
  }
  function watchAtc() {
    var pf = document.querySelector('product-form, .product-form');
    if (!pf || pf.__oatAtcObs) return;
    pf.__oatAtcObs = 1;
    try {
      var pend = false;
      var mo = new MutationObserver(function () {
        if (pend) return;             /* coalesce mutation bursts into one pass (INP) */
        pend = true;
        setTimeout(function () { pend = false; updateAtcPrice(); decorateSealPrices(); updateCardPrices(); }, 150);
      });
      mo.observe(pf, { childList: true, subtree: true });  /* dropped characterData, childList catches Dawn's re-render */
    } catch (e) {}
  }
  function currentVariant() {
    if (!variants.length) return null;
    var vid = null, idInput = document.querySelector('.product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idInput) vid = idInput.value;
    var i;
    for (i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) return variants[i]; }
    var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
    if (fs) { var rs = fs.querySelectorAll('input[type="radio"]'); for (i = 0; i < rs.length; i++) { if (rs[i].checked) return variants[i]; } }
    return variants[0];
  }
  function updateCalcSummary() {
    var trigger = document.querySelector('.oatentik-calc__trigger');
    if (!trigger || !trigger.classList.contains('is-selected')) return;
    var txtEl = trigger.querySelector('.oatentik-calc__trigger-txt');
    if (!txtEl) return;
    var v = currentVariant();
    var name = (v && v.title) ? v.title : '';
    if (!name) return;
    txtEl.textContent = '✓ ' + name + ' ' + ((CALC_COPY && CALC_COPY.sel) ? CALC_COPY.sel : 'selected');
  }
  function decorateSealPrices() {
    var v = currentVariant(); if (!v) return;
    var was = v.compare_money || '';
    var opts = document.querySelectorAll('.sls-option-container');
    for (var k = 0; k < opts.length; k++) {
      var priceEl = opts[k].querySelector('.sls-price'); if (!priceEl) continue;
      var ex = priceEl.querySelector('.oatentik-was');
      if (!was) { if (ex && ex.parentNode) ex.parentNode.removeChild(ex); continue; }
      if (ex) { if (ex.textContent !== was) ex.textContent = was; continue; }
      var s = document.createElement('s'); s.className = 'oatentik-was'; s.textContent = was;
      var money = priceEl.querySelector('.money');
      if (money) money.insertAdjacentElement('afterend', s); else priceEl.appendChild(s);
    }
  }
  function updateCardPrices() {
    var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
    if (!fs || !variants.length) return;
    var sub = oatNsubActive();
    var planId = sub ? oatNsubPlanId() : '';
    var labels = fs.querySelectorAll('input[type="radio"] + label, label.input--pill');
    if (!labels.length) labels = fs.querySelectorAll('label');
    labels.forEach(function (label, idx) {
      var v = variants[idx]; if (!v) return;
      var main = label.querySelector('.oatentik-pack-decor__price-main');
      if (main) {
        var plan = planId ? oatPlanFor(v, planId) : null;
        var p = sub ? ((plan && plan.price_money) || v.from_money || v.price_money || '') : (v.price_money || '');
        oatSetMoney(main, p);
      }
    });
  }

  /* ----- Mobile sticky add-to-cart bar ----- */
  var STICKY_CALC_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" stroke="#282828" stroke-width="1.6"/><line x1="8" y1="7" x2="16" y2="7" stroke="#282828" stroke-width="1.6" stroke-linecap="round"/><circle cx="9" cy="12" r="1" fill="#282828"/><circle cx="12.5" cy="12" r="1" fill="#282828"/><circle cx="16" cy="12" r="1" fill="#282828"/><circle cx="9" cy="16" r="1" fill="#282828"/><circle cx="12.5" cy="16" r="1" fill="#282828"/><circle cx="16" cy="16" r="1" fill="#282828"/></svg>';
  function stickyDecorLabels() {
    return document.querySelectorAll('label[data-oatentik-decorated="1"][data-vidx]');
  }
  function stickyVariantIndex() {
    var labels = stickyDecorLabels();
    for (var i = 0; i < labels.length; i++) {
      var r = labels[i].previousElementSibling;
      if (r && r.tagName === 'INPUT' && r.checked) { var n = parseInt(labels[i].dataset.vidx, 10); return isNaN(n) ? 0 : n; }
    }
    return 0;
  }
  function stickyPriceFor(v) {
    if (!v) return '';
    var sp = activePlanInput();
    var planId = (sp && sp.value) ? String(sp.value).trim() : '';
    if (planId && v.plans) {
      for (var i = 0; i < v.plans.length; i++) {
        if (String(v.plans[i].id) === planId && v.plans[i].price_money) return v.plans[i].price_money;
      }
      if (v.has_sub && v.from_money) return v.from_money;
    }
    return v.price_money || '';
  }
  function buildStickySheet() {
    var sheet = document.querySelector('.oat-sticky__sheet');
    if (!sheet) return;
    var labels = stickyDecorLabels();
    var sel = stickyVariantIndex();
    var seen = {};
    var html = '<div class="oat-sticky__sheet-title"></div>';
    labels.forEach(function (label) {
      var idx = parseInt(label.dataset.vidx, 10);
      if (isNaN(idx) || seen[idx]) return;
      seen[idx] = 1;
      var v = variants[idx];
      if (!v) return;
      var saveEl = label.querySelector('.oatentik-pack-decor__save');
      var save = (saveEl && !saveEl.hidden) ? saveEl.textContent : '';
      html += '<button type="button" class="oat-sticky__row' + (idx === sel ? ' is-active' : '') + '" data-vidx="' + idx + '">' +
                '<span class="oat-sticky__row-title"></span>' +
                '<span class="oat-sticky__row-right"><span class="oat-sticky__row-price"></span>' + (save ? '<span class="oat-sticky__row-save"></span>' : '') + '</span>' +
              '</button>';
    });
    html += '<hr class="oat-sticky__div">' +
            '<button type="button" class="oat-sticky__calcrow">' + STICKY_CALC_SVG + '<span></span></button>';
    sheet.innerHTML = html;
    /* fill texts via textContent to avoid HTML injection from money strings */
    var rows = sheet.querySelectorAll('.oat-sticky__row');
    rows.forEach(function (row) {
      var idx = parseInt(row.dataset.vidx, 10);
      var v = variants[idx];
      var label = document.querySelector('label[data-oatentik-decorated="1"][data-vidx="' + idx + '"]');
      var topEl = label ? label.querySelector('.oatentik-pack-decor__top') : null;
      var saveEl = label ? label.querySelector('.oatentik-pack-decor__save') : null;
      row.querySelector('.oat-sticky__row-title').textContent = topEl ? topEl.textContent : ((v && v.title) || '');
      oatSetMoney(row.querySelector('.oat-sticky__row-price'), stickyPriceFor(v));
      var sv = row.querySelector('.oat-sticky__row-save');
      if (sv) sv.textContent = (saveEl && !saveEl.hidden) ? saveEl.textContent : '';
    });
    var cr = sheet.querySelector('.oat-sticky__calcrow span');
    if (cr) cr.textContent = STICKY_CALC_LABEL || '';
    var st = sheet.querySelector('.oat-sticky__sheet-title');
    if (st) st.textContent = (PACK_LABEL || '').replace(/\s*[:：]\s*$/, '');
  }
  function stickySheetOpen(open) {
    var sheet = document.querySelector('.oat-sticky__sheet');
    var bg = document.querySelector('.oat-sticky__bg');
    if (!sheet || !bg) return;
    if (open) { buildStickySheet(); sheet.hidden = false; bg.hidden = false; oatPublish('oat_sticky_sheet_open'); }
    else { sheet.hidden = true; bg.hidden = true; }
  }
  function buildStickyPills(bar) {
    var box = bar.querySelector('.oat-sticky__pills');
    if (!box) return;
    var labels = stickyDecorLabels();
    if (!labels.length) return;
    var sel = stickyVariantIndex();
    var seen = {};
    box.innerHTML = '';
    labels.forEach(function (label) {
      var idx = parseInt(label.dataset.vidx, 10);
      if (isNaN(idx) || seen[idx]) return;
      seen[idx] = 1;
      var v = variants[idx];
      if (!v) return;
      var topEl = label.querySelector('.oatentik-pack-decor__top');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oat-sticky__pill' + (idx === sel ? ' is-active' : '');
      b.dataset.vidx = idx;
      var t = document.createElement('span');
      t.className = 'oat-sticky__pill-label';
      t.textContent = topEl ? topEl.textContent : (v.title || '');
      var p = document.createElement('span');
      p.className = 'oat-sticky__pill-price';
      p.innerHTML = oatSmallCents(stickyPriceFor(v));
      b.appendChild(t);
      b.appendChild(p);
      b.addEventListener('click', function () {
        selectPack(idx);
        setTimeout(updateStickyAtc, 120);
      });
      box.appendChild(b);
    });
  }
  function updateStickyAtc() {
    var bar = document.querySelector('.oat-sticky');
    if (!bar || !variants.length) return;
    var idx = stickyVariantIndex();
    var v = variants[idx] || variants[0];
    if (!v) return;
    var label = document.querySelector('label[data-oatentik-decorated="1"][data-vidx="' + idx + '"]');
    var topEl = label ? label.querySelector('.oatentik-pack-decor__top') : null;
    var segTop = bar.querySelector('.oat-sticky__seg-top');
    var segPrice = bar.querySelector('.oat-sticky__seg-price');
    var makesEl = label ? label.querySelector('.oatentik-pack-decor__makes') : null;
    var topTxt = topEl ? topEl.textContent : (v.title || '');
    if (makesEl) topTxt += ' · ' + makesEl.textContent.replace(/^\s*=\s*/, '');
    if (segTop) segTop.textContent = topTxt;
    if (segPrice) oatSetMoney(segPrice, stickyPriceFor(v));
    var segSave = bar.querySelector('.oat-sticky__seg-save');
    if (segSave) {
      var saveEl = label ? label.querySelector('.oatentik-pack-decor__save') : null;
      segSave.textContent = (saveEl && !saveEl.hidden) ? saveEl.textContent : '';
    }
    var pillBox = bar.querySelector('.oat-sticky__pills');
    if (pillBox) {
      if (!pillBox.children.length) buildStickyPills(bar);
      var pills = pillBox.querySelectorAll('.oat-sticky__pill');
      pills.forEach(function (p) {
        var pi = parseInt(p.dataset.vidx, 10);
        var pv = variants[pi];
        var pp = p.querySelector('.oat-sticky__pill-price');
        if (pv && pp) oatSetMoney(pp, stickyPriceFor(pv));
        p.classList.toggle('is-active', pi === idx);
      });
    }
    var atc = bar.querySelector('.oat-sticky__atc');
    var real = document.querySelector('.product-form__submit');
    if (atc) {
      var txt = real ? (real.innerText || '').trim() : '';
      if (txt && atc.textContent !== txt) atc.textContent = txt;
    }
  }
  function injectStickyAtc() {
    if (document.querySelector('.oat-sticky')) return true;
    if (!variants.length) return false;
    var target = document.querySelector('.product-form__buttons');
    if (!target) return false;
    var bar = document.createElement('div');
    bar.className = 'oat-sticky';
    bar.innerHTML =
      '<button type="button" class="oat-sticky__seg" aria-haspopup="true" aria-expanded="false">' +
        '<span class="oat-sticky__seg-top"></span>' +
        '<span class="oat-sticky__seg-price"></span>' +
        '<span class="oat-sticky__seg-save"></span>' +
        '<span class="oat-sticky__seg-chev" aria-hidden="true">▴</span>' +
      '</button>' +
      '<div class="oat-sticky__pills"></div>' +
      '<button type="button" class="oat-sticky__calc" aria-label="Calculator">' + STICKY_CALC_SVG + '</button>' +
      '<button type="button" class="oat-sticky__atc"></button>';
    var bg = document.createElement('div');
    bg.className = 'oat-sticky__bg';
    bg.hidden = true;
    var sheet = document.createElement('div');
    sheet.className = 'oat-sticky__sheet';
    sheet.hidden = true;
    document.body.appendChild(bar);
    document.body.appendChild(bg);
    document.body.appendChild(sheet);
    var seg = bar.querySelector('.oat-sticky__seg');
    seg.addEventListener('click', function () {
      var open = sheet.hidden;
      stickySheetOpen(open);
      seg.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    bg.addEventListener('click', function () { stickySheetOpen(false); seg.setAttribute('aria-expanded', 'false'); });
    bar.querySelector('.oat-sticky__calc').addEventListener('click', function () {
      stickySheetOpen(false);
      var t = document.querySelector('.oatentik-calc__trigger');
      if (t) t.click();
    });
    bar.querySelector('.oat-sticky__atc').addEventListener('click', function () {
      oatPublish('oat_sticky_atc', { variant_index: stickyVariantIndex() });
      var b = document.querySelector('.product-form__submit');
      if (b) b.click();
    });
    sheet.addEventListener('click', function (e) {
      var row = e.target.closest ? e.target.closest('.oat-sticky__row') : null;
      if (row) {
        var idx = parseInt(row.dataset.vidx, 10);
        if (!isNaN(idx)) selectPack(idx);
        stickySheetOpen(false);
        seg.setAttribute('aria-expanded', 'false');
        setTimeout(updateStickyAtc, 120);
        return;
      }
      var cr = e.target.closest ? e.target.closest('.oat-sticky__calcrow') : null;
      if (cr) {
        stickySheetOpen(false);
        seg.setAttribute('aria-expanded', 'false');
        var t = document.querySelector('.oatentik-calc__trigger');
        if (t) t.click();
      }
    });
    /* Visibility: show only after scrolling past the real buy buttons */
    function stickyShow(on) {
      if (on) { bar.classList.add('oat-sticky--on'); }
      else { bar.classList.remove('oat-sticky--on'); stickySheetOpen(false); seg.setAttribute('aria-expanded', 'false'); }
    }
    if ('IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          stickyShow(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
        io.observe(target);
      } catch (e2) {}
    } else {
      var stTick = false;
      window.addEventListener('scroll', function () {
        if (stTick) return;
        stTick = true;
        setTimeout(function () {
          stTick = false;
          var el = document.querySelector('.product-form__buttons');
          if (!el) return;
          var r = el.getBoundingClientRect();
          stickyShow(r.bottom < 0);
        }, 150);
      }, { passive: true });
    }
    buildStickyPills(bar);
    updateStickyAtc();
    return true;
  }

  /* ----- "Is OATENTIK for you?", inject localized heading + qualifier checklist into the FIRST accordion ----- */
  function injectIsForYou() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    var accs = info.querySelectorAll('.product__accordion details');
    if (!accs.length) accs = info.querySelectorAll('details');
    if (!accs.length) return false;
    var host = accs[0];  /* Is OATENTIK for you = first accordion */
    var titleEl = host.querySelector('.accordion__title') || host.querySelector('.summary__title');
    if (titleEl && IFU.heading) titleEl.textContent = IFU.heading;
    var content = host.querySelector('.accordion__content, .product__accordion-content, .rte');
    if (!content) {
      var sm0 = host.querySelector('summary');
      for (var j0 = 0; j0 < host.children.length; j0++) { if (host.children[j0] !== sm0) { content = host.children[j0]; break; } }
    }
    if (!content) return false;
    if (content.querySelector('.oatentik-ifu-acc')) return true;
    var ih = '<div class="oatentik-ifu-acc">';
    if (IFU.sub) ih += '<p class="oatentik-ifu-acc__sub">' + IFU.sub + '</p>';
    ih += '<ul class="oatentik-ifu-acc__list">';
    for (var ii = 0; ii < IFU.items.length; ii++) {
      ih += '<li class="oatentik-ifu-acc__item"><span class="oatentik-ifu-acc__check">' + ICON_CHECK + '</span><span>' + IFU.items[ii] + '</span></li>';
    }
    ih += '</ul></div>';
    content.innerHTML = ih;
    return true;
  }

  /* ----- How to use: inject enhanced body + tappable use-case chips into the SECOND accordion ----- */
  function injectHowToUse() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    var accs = info.querySelectorAll('.product__accordion details');
    if (!accs.length) accs = info.querySelectorAll('details');
    if (!accs.length) return false;
    var host = accs[1];  /* How to use is the second accordion (Is-for-you is first) */
    var content = host.querySelector('.accordion__content, .product__accordion-content, .rte');
    if (!content) {
      var sum = host.querySelector('summary');
      for (var j = 0; j < host.children.length; j++) { if (host.children[j] !== sum) { content = host.children[j]; break; } }
    }
    if (!content) return false;
    if (content.querySelector('.oatentik-howto')) return true;  /* already injected */
    var html = '<div class="oatentik-howto">';
    html += '<p class="oatentik-howto__body">' + HTU.body + '</p>';
    html += '<div class="oatentik-howto__try">' + HTU.tryLabel + '</div>';
    html += '<div class="oatentik-howto__chips" role="tablist">';
    for (var i = 0; i < HTU.chips.length; i++) {
      html += '<button type="button" class="oatentik-howto__chip" data-idx="' + i + '" aria-pressed="false">' + HTU.chips[i].icon + '<span>' + HTU.chips[i].label + '</span></button>';
    }
    html += '</div>';
    html += '<div class="oatentik-howto__tip" aria-live="polite"></div>';
    html += '</div>';
    content.innerHTML = html;
    var wrap = content.querySelector('.oatentik-howto');
    var chipEls = wrap.querySelectorAll('.oatentik-howto__chip');
    var tipEl = wrap.querySelector('.oatentik-howto__tip');
    function activate(idx) {
      for (var k = 0; k < chipEls.length; k++) {
        var on = (k === idx);
        chipEls[k].classList.toggle('is-active', on);
        chipEls[k].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      tipEl.textContent = HTU.chips[idx] ? HTU.chips[idx].tip : '';
    }
    for (var m = 0; m < chipEls.length; m++) {
      (function (idx) {
        chipEls[idx].addEventListener('click', function (e) { e.preventDefault(); activate(idx); });
      })(m);
    }
    activate(0);
    return true;
  }

  /* ----- Localize the related-products heading ("You may also like"), section loads async ----- */
  var REL_HEADING = C.k54;
  function localizeRelated() {
    var els = document.querySelectorAll('.related-products__heading');
    for (var ri = 0; ri < els.length; ri++) {
      var rel = els[ri], cur = (rel.textContent || '').trim();
      if (cur && cur !== REL_HEADING) rel.textContent = REL_HEADING;
    }
  }

  /* ----- Accordions: ALL CLOSED BY DEFAULT (Marjana, 2026-08-19) -----
     This function used to force the FIRST accordion open on load:
         var target = list[0];
         if (target && !target.open) { target.open = true; }
     Its own comment said "How to use is first in block_order", and that had gone
     stale: block_order now starts with collapsible_is_for_you, so what it really
     opened was "Is OATENTIK for you?".
     She asked for every tab to start closed, so the body is a no-op. The two call
     sites are deliberately LEFT IN PLACE rather than deleted, so restoring the old
     behaviour means putting those two lines back here and changing nothing else.
     Worth knowing: the server already renders every <details> WITHOUT an open
     attribute. This JS was the only thing opening one. ----- */
  function openIngredientsDefault() {
    return;
  }

  /* ----- Style native accordion links (e.g. "View certificates") as pills ----- */
  function styleAccordionLinks() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return;
    var links = info.querySelectorAll('.product__accordion a, .accordion__content a, .product__accordion-content a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.classList.contains('oatentik-nutrition-link') || a.classList.contains('oatentik-doc-link')) continue;
      a.classList.add('oatentik-doc-link');
      var lbl = (a.textContent || '').replace(/\s+/g, ' ').trim();
      a.innerHTML = ICON_DOC + '<span>' + lbl + '</span>';
    }
  }

  /* ----- Autoplay first gallery media if it's a video (e.g. Barista unboxing hero), muted ----- */
  function autoplayHeroVideo() {
    if (window.__oatHeroVidDone) return;
    var firstItem = document.querySelector('.product__media-list .product__media-item') || document.querySelector('.product__media-item');
    if (!firstItem) return;
    var def = firstItem.querySelector('deferred-media');
    if (!def) { window.__oatHeroVidDone = 1; return; }  /* first media is an image, nothing to do */
    window.__oatHeroVidDone = 1;
    try { if (typeof def.loadContent === 'function') { def.loadContent(false); } else { var b = def.querySelector('button'); if (b) b.click(); } } catch (e) {}
    var n = 0;
    var iv = setInterval(function () {
      var v = def.querySelector('video');
      if (v) {
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true; v.removeAttribute('controls');
        var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); }
        clearInterval(iv);
      } else if (++n > 25) { clearInterval(iv); }
    }, 150);
  }

  /* ----- Post-ATC Matcha Latte upsell (native, fires on Add-to-cart of the oat powder).
   *  The launch price is the Matcha 1-pack variant price (€26, was €30); the badge percent
   *  is computed from the real variant compare-at price. ----- */
  function initUpsell() {
    if (window.__oatUpsellInit) return;
    var mxEl = document.getElementById('oatentik-upsell-data');
    var mxTpl = document.getElementById('oatentik-upsell-template');
    var frEl = document.getElementById('oatentik-upsell-frother-data');
    var frTpl = document.getElementById('oatentik-upsell-frother-template');
    var mxData = null, frData = null;
    try { if (mxEl) mxData = JSON.parse(mxEl.textContent); } catch (e) {}
    try { if (frEl) frData = JSON.parse(frEl.textContent); } catch (e) {}
    var MATCHA  = (mxData && mxData.id && mxTpl) ? { data: mxData, tpl: mxTpl, label: 'matcha' } : null;
    var FROTHER = (frData && frData.id && frTpl) ? { data: frData, tpl: frTpl, label: 'frother' } : null;
    if (!MATCHA && !FROTHER) return; /* nothing available to upsell, no-op */
    window.__oatUpsellInit = true;
    var KEY = 'oatUpsellShown';
    /* Hold the drawer from the very first moment of ATC (capture-phase submit),
       BEFORE Dawn's product-form handler runs, eliminates the open-then-close
       flash while the popup decision (cart fetch) is in flight. Safety: auto-
       release after 2.5s if the popup never opened (network error etc.). */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      if (wasShown()) return;
      window.__oatHoldDrawer = true;
      setTimeout(function () {
        var ov = document.body.querySelector('.oat-upsell__overlay');
        if (window.__oatHoldDrawer && (!ov || ov.hidden)) oatReleaseDrawer(true);
      }, 2500);
    }, true);
    /* Option A: hold the side cart drawer until the Matcha popup is dismissed,
       so a qualifying ATC shows ONE thing at a time (popup first, cart after). */
    (function () {
      var d = document.querySelector('cart-drawer');
      if (d && !d.__oatHoldPatched) {
        d.__oatHoldPatched = true;
        var protoOpen = Object.getPrototypeOf(d).open;
        d.open = function (t) {
          if (window.__oatHoldDrawer) { d.__oatPendingTrigger = t || d.__oatPendingTrigger; return; }
          return protoOpen.call(d, t);
        };
      }
    })();
    function oatReleaseDrawer(openIt) {
      window.__oatHoldDrawer = false;
      if (openIt) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { try { d.open(d.__oatPendingTrigger); } catch (e) {} }
      }
    }
    function wasShown() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    function markShown() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
    function track(name, extra) {
      try { window.dataLayer = window.dataLayer || []; var p = { event: name }; for (var k in (extra || {})) { p[k] = extra[k]; } window.dataLayer.push(p); } catch (e) {}
      oatPublish(name, extra || {});
    }
    var overlay = null;
    var current = null; /* the cfg (MATCHA or FROTHER) currently being offered */
    function buildPopup(cfg) {
      if (overlay) return overlay;
      document.body.appendChild(cfg.tpl.content.cloneNode(true));
      var ovs = document.body.querySelectorAll('.oat-upsell__overlay');
      overlay = ovs[ovs.length - 1];
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup('backdrop'); });
      overlay.querySelector('.oat-upsell__close').addEventListener('click', function () { closePopup('close'); });
      overlay.querySelector('.oat-upsell__decline').addEventListener('click', function () { closePopup('decline'); });
      overlay.querySelector('.oat-upsell__cta').addEventListener('click', function () { addProduct(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closePopup('esc'); });
      return overlay;
    }
    function openPopup(cfg) {
      current = cfg;
      buildPopup(cfg);
      /* belt-and-suspenders: make sure the side cart is closed so the upsell popup
         is the ONLY overlay, even if the hold patch missed (cached JS, race). */
      try {
        window.__oatHoldDrawer = true;
        var dd = document.querySelector('cart-drawer');
        if (dd && dd.classList.contains('active') && typeof dd.close === 'function') dd.close();
      } catch (e) {}
      overlay.hidden = false;
      document.documentElement.classList.add('oat-upsell-lock');
      markShown();
      track('oat_upsell_view', { product: cfg.label, variant_id: cfg.data.id });
      try { var cb = overlay.querySelector('.oat-upsell__close'); if (cb) cb.focus({ preventScroll: true }); } catch (e) {}
    }
    function closePopup(reason) {
      if (!overlay || overlay.hidden) return;
      overlay.hidden = true;
      document.documentElement.classList.remove('oat-upsell-lock');
      if (reason && reason !== 'atc') track('oat_upsell_decline', { method: reason, product: current ? current.label : '' });
      /* declined/closed the popup, now open the cart we held back */
      if (reason !== 'atc') oatReleaseDrawer(true);
    }
    function addProduct() {
      if (!current) return;
      var btn = overlay.querySelector('.oat-upsell__cta');
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      /* Same sections-refresh approach as Dawn's product-form.js so drawer/bubble re-render */
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var payload = { items: [{ id: current.data.id, quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        } catch (e) {}
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          btn.classList.remove('is-loading');
          if (resp && resp.status && resp.status !== 200) return; /* add failed, keep popup so the user can retry */
          track('oat_upsell_atc', { product: current.label, variant_id: current.data.id });
          closePopup('atc');
          try {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'oat-upsell', productVariantId: current.data.id, cartData: resp });
            }
          } catch (e) {}
          window.__oatHoldDrawer = false; /* release so the cart opens with the added item in it */
          try { if (cart && typeof cart.renderContents === 'function' && resp.sections) cart.renderContents(resp); } catch (e) {}
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    }
    function inCart(items, cfg) {
      if (!cfg) return false;
      var pid = cfg.data.product_id, vid = cfg.data.id;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if ((pid && it.product_id === pid) || it.variant_id === vid || it.id === vid) return true;
      }
      return false;
    }
    function maybeShow() {
      if (wasShown()) { oatReleaseDrawer(true); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (wasShown()) { oatReleaseDrawer(true); return; }
          var items = (c && c.items) || [];
          var hasMatcha = inCart(items, MATCHA);
          var hasFrother = inCart(items, FROTHER);
          var cfg = null;
          if (MATCHA && !hasMatcha) { cfg = MATCHA; }                 /* oat / other buyer -> Matcha launch */
          else if (FROTHER && hasMatcha && !hasFrother) { cfg = FROTHER; } /* matcha buyer -> frother companion */
          if (cfg) { setTimeout(function () { openPopup(cfg); }, 80); } /* drawer held, show the popup first */
          else { oatReleaseDrawer(true); } /* nothing relevant to offer, just open the cart */
        })
        .catch(function () { oatReleaseDrawer(true); });
    }
    /* Trigger: Dawn pubsub when exposed; otherwise patch fetch for /cart/add */
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source === 'oat-upsell') return;
        /* hold the drawer synchronously (before Dawn's renderContents opens it);
           maybeShow() reads the cart and decides which popup, if any, to show */
        if (!wasShown()) { window.__oatHoldDrawer = true; }
        maybeShow();
      });
    } else {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = typeof args[0] === 'string' ? args[0] : ((args[0] && args[0].url) || '');
        var p = origFetch.apply(this, args);
        if (url.indexOf('/cart/add') !== -1) {
          p.then(function (res) {
            if (!res || !res.ok) return;
            try {
              res.clone().json().then(function () {
                maybeShow();
              }).catch(function () {});
            } catch (e) {}
          }).catch(function () {});
        }
        return p;
      };
    }
  }

  function injectNativeRating() {
    var tpl = document.getElementById('oatentik-native-rating');
    if (!tpl) return;
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info || info.querySelector('.oatentik-nrating')) return;
    var kl = info.querySelector('[class*="klaviyo"], [class*="kl_reviews"]');
    var node = tpl.content.cloneNode(true);
    if (kl) {
      var host = kl.closest('.shopify-block') || kl;
      host.parentNode.insertBefore(node, host);
      host.style.display = 'none'; /* Klaviyo's star block isn't localized, native row replaces it */
    } else {
      var t = info.querySelector('.product__title, h1');
      if (!t) return;
      t.parentNode.insertBefore(node, t);
    }
    var btn = info.querySelector('.oatentik-nrating');
    if (btn) btn.addEventListener('click', function () {
      var sec = document.querySelector('.oat-pr');
      if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* CPA: default-select the 2-pack ("Most Popular", free shipping) instead of the
     cheapest 1-bag, but never override an explicit ?variant= ad link, and only
     before the visitor touches the picker. */
  var __oatDefaultPackDone = false;
  function defaultPackOnce() {
    if (__oatDefaultPackDone) return;
    try {
      if (/[?&]variant=/.test(window.location.search)) { __oatDefaultPackDone = true; return; }
      var fs = document.querySelector('fieldset.product-form__input, .product-form__input--pill');
      if (!fs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (radios.length < 2 || !radios[1]) return;
      if (!variants || variants.length < 2) return;
      var checkedIdx = -1;
      for (var i = 0; i < radios.length; i++) { if (radios[i].checked) { checkedIdx = i; break; } }
      if (checkedIdx !== 0) { __oatDefaultPackDone = true; return; }
      __oatDefaultPackDone = true;
      selectPack(1);
    } catch (e) { __oatDefaultPackDone = true; }
  }

  function init() {
    buildOrderBox();
    injectNativeRating();
    injectNutritionButton();
    injectIsForYou();
    injectHowToUse();
    openIngredientsDefault();
    styleAccordionLinks();
    localizeRelated();
    /* injectIntoIngredients(); disabled, Ingredients accordion uses modal link */
    decoratePackPicker();
    defaultPackOnce();
    injectCalc();
    injectJourneySlider();
    injectTrustLine();
    injectGifts();
    wireGiftRideAlong();
    syncTinLock();
    initNativeSub();
    polishSeal();
    injectSubPayNote();
    updateAtcPrice();
    decorateSealPrices();
    updateCardPrices();
    updateNativeSub();
    injectGalleryArrows();
    autoplayHeroVideo();
    injectStickyAtc();
    updateStickyAtc();
    initUpsell();

    /* Re-run when Dawn re-renders the form after variant change */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        __oatDefaultPackDone = true;
        setTimeout(decoratePackPicker, 50);
        setTimeout(updateAtcPrice, 70);
        setTimeout(updateCalcSummary, 110);
        setTimeout(syncTinLock, 90);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sls-option-container')) { setTimeout(updateAtcPrice, 90); setTimeout(updateCardPrices, 90); setTimeout(updateCalcSummary, 110); setTimeout(injectSubPayNote, 90); }
    });

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      buildOrderBox();
      injectNativeRating();
      injectNutritionButton();
      injectIsForYou();
      injectHowToUse();
      openIngredientsDefault();
      styleAccordionLinks();
      localizeRelated();
      /* injectIntoIngredients(); disabled, Ingredients accordion uses modal link */
      decoratePackPicker();
      defaultPackOnce();
      injectCalc();
      injectJourneySlider();
      injectTrustLine();
      injectGifts();
      wireGiftRideAlong();
      syncTinLock();
      initNativeSub();
      polishSeal();
      injectSubPayNote();
      updateAtcPrice();
      decorateSealPrices();
      updateCardPrices();
      updateNativeSub();
      injectGalleryArrows();
      autoplayHeroVideo();
      injectStickyAtc();
      updateStickyAtc();
      if (attempts > 30) clearInterval(timer);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
